export const checkIsEmail = (value: string): boolean => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return re.test(value)
}

export const checkIsPhone = (value: string): boolean => {
  const re = /^\+?[0-9]{10,15}$/
  return re.test(value)
}
